<div class="header">
  <!-- Interface-Typ direkt rechts neben der Überschrift: gilt für alle Reiter
       darunter und alle Agents mit diesem Styling (styles.widgetDesign:
       Liquid = 'liquid', Chat = 'window'). Stil wie Login | Register. -->
  <div class="header-title">
    <h2>{{ "pages.chatStyling.title" | translate }}</h2>
    <div
      class="interface-switch"
      alAnchor="chat-styling.interface"
      role="radiogroup"
      [attr.aria-label]="'pages.chatStyling.interfaceType.label' | translate"
      [nbTooltip]="(interfaceType ? 'pages.chatStyling.interfaceType.hint.' + interfaceType : 'pages.chatStyling.interfaceType.hint.auto') | translate"
      nbTooltipPlacement="bottom"
      *ngIf="loaded"
    >
      <button
        *ngFor="let o of interfaceOptions"
        type="button"
        role="radio"
        class="interface-switch__btn"
        [class.active]="interfaceType === o.value"
        [attr.aria-checked]="interfaceType === o.value"
        (click)="onInterfaceType(o.value)"
      >{{ o.label }}</button>
    </div>
    <!-- Nichts gewählt: sichtbar sagen, was dann gilt — der Tooltip am
         Schalter allein reichte nicht, Kunden sahen nur „nichts markiert“ -->
    <span class="interface-auto" *ngIf="loaded && !interfaceType">
      {{ 'pages.chatStyling.interfaceType.autoLabel' | translate }}
    </span>
  </div>
  <div class="header-actions">
    <nb-select
      *ngIf="(chatService.chatSettings$ | async)?.length"
      [selected]="selectedChatStyle?.id"
      alAnchor="chat-styling.select"
      (selectedChange)="onSelectById($event)"
    >
      <nb-option *ngFor="let s of chatService.chatSettings$ | async" [value]="s.id">
        {{ s.widget_instance }}
      </nb-option>
    </nb-select>
    <button
      nbButton
      status="basic"
      class="btn-circle btn-circle--edit"
      *ngIf="selectedChatStyle"
      (click)="onAdd(selectedChatStyle)"
    >
      <nb-icon icon="edit"></nb-icon>
    </button>
    <button
      nbButton
      status="basic"
      class="btn-circle btn-circle--delete"
      *ngIf="selectedChatStyle"
      (click)="onDelete(selectedChatStyle, $event)"
    >
      <nb-icon icon="trash"></nb-icon>
    </button>
    <button nbButton status="primary" (click)="onAdd()" alAnchor="chat-styling.add">
      <nb-icon icon="plus"></nb-icon>
      {{ "buttons.add" | translate }}
    </button>
  </div>
</div>


<!-- The grid renders as soon as this page's own list request is done
     (`loaded`) — with or without a style. Without one, the left column shows the settings form with the
     default styling (DEFAULT_CHAT_STYLES) and the preview shows the same, so
     a fresh client sees on the first visit what can be styled. -->
<div class="grid" *ngIf="loaded">
  <!-- Column 1: Settings Form. Ohne eigenes Styling gesperrt: jede Eingabe
       öffnet den Namensdialog, das Standard-Design bleibt unverändert
       (bindDefaultGate in der .ts). -->
  <nb-card size="small" class="settings-card" alAnchor="chat-styling.settings">
    <nb-card-body>
      <div #settingsFormHost>
        <app-chat-settings-form
          [section]="activeSection"
          [chatSettingsId]="selectedChatStyle?.id"
          [locked]="!selectedChatStyle"
          (lockedEdit)="onAdd()"
          (stylesChange)="onStylesChange($event)"
        ></app-chat-settings-form>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Column 2: Live Preview -->
  <nb-card size="small" class="preview-card" alAnchor="chat-styling.preview">
    <nb-card-body>
      <!-- Zwei Reiter (Marcel, 08.10.2026): rechts nur die Vorschau; die linke
           Karte zeigt die Einstellungen des gewählten Reiters ([section]). -->
      <nb-tabset class="preview-tabs" (changeTab)="onPreviewTab($event)">
        <nb-tab tabId="window" [tabTitle]="(commandLook ? 'pages.chatStyling.preview.sectionCanvas' : 'pages.chatStyling.preview.sectionChatWindow') | translate">
          <div class="preview-col">
            <div
              *ngIf="!commandLook"
              class="chat-preview"
              [style.background]="paint.windowFill"
              [style.font-family]="previewStyles.fontFamily || 'Roboto, sans-serif'"
            >
              <!-- Header -->
              <div
                class="chat-header"
                [style.border-color]="paint.primaryInk"
              >
                <div class="chat-header-left">
                  <img
                    class="chat-logo"
                    [src]="previewStyles.logo || 'assets/icons/Alphabot.svg'"
                    alt="Bot"
                    [style.height.px]="previewStyles.logoSize || 28"
                    (error)="$any($event.target).src = 'assets/icons/Alphabot.svg'"
                  />
                </div>
                <span class="chat-title">{{
                  selectedChatStyle?.widget_instance || ("pages.chatStyling.preview.defaultTitle" | translate)
                }}</span>
                <div class="chat-header-actions">
                  <nb-icon icon="expand-outline" class="header-icon"></nb-icon>
                  <nb-icon icon="close-outline" class="header-icon"></nb-icon>
                </div>
              </div>

              <!-- Messages -->
              <div class="chat-messages">
                <div class="msg-row user">
                  <div
                    class="msg-bubble user-bubble"
                    [style.background]="paint.userBubbleFill"
                    [style.color]="paint.userTextInk"
                  >
                    {{ "pages.chatStyling.preview.sampleUserMessage" | translate }}
                  </div>
                  <span class="msg-time">09:46</span>
                </div>

                <div class="msg-row bot">
                  <div
                    class="msg-bubble bot-bubble"
                    [style.background]="paint.secondaryFill"
                    [style.color]="paint.botTextInk"
                  >
                    {{ "pages.chatStyling.preview.sampleBotMessage" | translate }}
                  </div>
                  <div class="bot-actions">
                    <nb-icon
                      icon="bookmark-outline"
                      class="action-icon"
                      [style.color]="paint.primaryInk"
                    ></nb-icon>
                    <nb-icon
                      icon="heart-outline"
                      class="action-icon"
                      [style.color]="paint.primaryInk"
                    ></nb-icon>
                  </div>
                </div>
              </div>

              <!-- Input -->
              <div class="chat-input-bar">
                <button
                  class="chat-attach-btn"
                  [style.color]="paint.primaryInk"
                >
                  <nb-icon icon="plus-circle-outline"></nb-icon>
                </button>
                <div class="chat-input-field">
                  <span class="chat-placeholder">{{
                    previewStyles.inputPlaceholder || ("pages.chatStyling.preview.defaultPlaceholder" | translate)
                  }}</span>
                </div>
                <div
                  class="chat-send-btn"
                  [style.background]="paint.primaryFill"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                  </svg>
                </div>
              </div>

              <!-- Branding -->
              <div
                class="chat-branding"
                *ngIf="previewStyles.alphabeesBranding !== false"
              >
                {{ "pages.chatStyling.preview.brandingPrefix" | translate }} &nbsp;
                <img
                  src="assets/images/Alphabees_LogoIcon_2026_indigo.svg"
                  alt="Alphabees"
                  class="branding-icon"
                />
                <span>Alphabees</span>
              </div>
            </div>

            <!-- Interface Liquid: das Widget geht in Dauerschleife auf und zu, ein
                 3D-Mauszeiger führt durch (liquid-demo, Bewegung wie im Widget). -->
            <app-liquid-demo
              *ngIf="commandLook"
              scenario="canvas"
              [styles]="previewStyles"
              [active]="activeSection === 'window'"
            ></app-liquid-demo>


          </div>
        </nb-tab>

        <nb-tab tabId="bubble" [tabTitle]="(commandLook ? 'pages.chatStyling.preview.sectionOrbiBar' : 'pages.chatStyling.preview.sectionChatBubble') | translate">
          <div class="preview-col">
            <!-- Interface Liquid: Pop-up-Nachricht ploppt über Orbi auf, der
                 Zeiger fährt über Orbi, die Leiste fährt auf, Vorschläge kommen. -->
            <app-liquid-demo
              *ngIf="commandLook"
              scenario="bar"
              [styles]="previewStyles"
              [active]="activeSection === 'bubble'"
              [typeText]="'pages.chatStyling.preview.command.typing' | translate"
            ></app-liquid-demo>

            <div class="bubble-preview" *ngIf="!commandLook">
              <!-- Pop-up-Nachricht (proaktive Frage) links oben an der Blase, wie
                   app-interactive-question im chat-widget: über der Blase,
                   rechtsbündig, nach links wachsend. Farben aus popupPreview
                   (rgba-Hintergrund, Schrift deckend). -->
              <div
                class="popup-preview"
                [style.font-family]="previewStyles.fontFamily || 'Roboto, sans-serif'"
              >
                <div class="popup-message" [ngStyle]="popupPreview.message">
                  <p class="popup-category">{{ "pages.chatStyling.preview.popupCategory" | translate }}</p>
                  <p class="popup-question">{{ "pages.chatStyling.preview.popupQuestion" | translate }}</p>
                  <nb-icon icon="close-outline" class="popup-close" aria-hidden="true"></nb-icon>
                </div>
                <div class="popup-replies">
                  <span class="popup-reply" [ngStyle]="popupPreview.reply">{{
                    "pages.chatStyling.preview.popupReplySummary" | translate
                  }}</span>
                  <span class="popup-reply" [ngStyle]="popupPreview.reply">{{
                    "pages.chatStyling.preview.popupReplyNo" | translate
                  }}</span>
                </div>
              </div>

              <!-- Bubble preview — variant switches between dot / blob / glass (label „Orbi“).
                   Falls back to legacy enableChatBubbleAnimation when chatBubbleStyle
                   is not yet set on a saved style record. -->
              <div class="chat-bubble-real" [attr.data-style]="bubbleStylePreview">
                <ng-container *ngIf="bubbleStylePreview === 'blob'">
                  <div class="wobble type-3"
                    [style.background]="paint.bubbleSecondaryFill"></div>
                  <div class="wobble type-2"
                    [style.background]="paint.primaryFill"></div>
                  <div class="wobble type-1"
                    [style.background]="paint.primaryFill"></div>
                </ng-container>
                <div *ngIf="bubbleStylePreview === 'dot'"
                  class="bubble-bg"
                  [style.background]="paint.primaryFill"></div>

                <!-- Stil „Orbi" (gespeicherter Wert bleibt 'glass'): der Tutor-Orbi
                     mit Augen und Lab-Animationen, derselbe Ablauf wie in der
                     echten Chat-Blase (app-orbi-launcher im chat-widget), in der
                     Vorschau etwas größer (72 → 80px Box). -->
                <app-orbi-lab
                  *ngIf="bubbleStylePreview === 'glass'"
                  class="bubble-orbi-preview"
                  type="tutor"
                  [size]="72"
                  [script]="orbiBubbleScript"
                ></app-orbi-lab>

                <ng-container *ngIf="bubbleStylePreview !== 'glass'">
                  <img
                    *ngIf="previewStyles.chatBubbleIcon"
                    [src]="previewStyles.chatBubbleIcon"
                    class="bubble-custom-icon"
                    [style.width.px]="previewStyles.chatBubbleIconSize || 28"
                    [style.height.px]="previewStyles.chatBubbleIconSize || 28"
                    alt="Chat"
                    (error)="$any($event.target).src = 'assets/icons/Alphabot.svg'"
                  />
                  <svg *ngIf="!previewStyles.chatBubbleIcon" viewBox="0 0 24 24" class="bubble-svg"
                    [style.width.px]="previewStyles.chatBubbleIconSize || 28"
                    [style.height.px]="previewStyles.chatBubbleIconSize || 28"
                  >
                    <g data-name="Layer 2">
                      <g data-name="message-square">
                        <rect width="24" height="24" opacity="0"></rect>
                        <circle cx="12" cy="11" r="1"></circle>
                        <circle cx="16" cy="11" r="1"></circle>
                        <circle cx="8" cy="11" r="1"></circle>
                        <path
                          d="M19 3H5a3 3 0 0 0-3 3v15a1 1 0 0 0 .51.87A1 1 0 0 0 3 22a1 1 0 0 0 .51-.14L8 19.14a1 1 0 0 1 .55-.14H19a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm1 13a1 1 0 0 1-1 1H8.55a3 3 0 0 0-1.55.43l-3 1.8V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </ng-container>
              </div>
            </div>

          </div>
        </nb-tab>

        <!-- Interaktive Lernhilfen (20.10.2026): Stil-Bausteine + Ladevariante.
             Leere Felder = „Automatisch“ (aid-style.ts). -->
        <nb-tab tabId="aids" [tabTitle]="'pages.chatStyling.preview.sectionAids' | translate">
          <div class="preview-col preview-col--aids">
            <app-aid-style-preview [styles]="previewStyles" [active]="activeSection === 'aids'" [frame]="commandLook"></app-aid-style-preview>
          </div>
        </nb-tab>
      </nb-tabset>

      <div class="preview-label">
        {{ "pages.chatStyling.preview.label" | translate }}
      </div>
    </nb-card-body>
  </nb-card>
</div>

